var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 10,
    fill: "#EB1729"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 678,
    width: 113,
    height: 10,
    fill: "#FDB80C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 339,
    width: 113,
    height: 10,
    fill: "#C31A30"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1017,
    width: 113,
    height: 10,
    fill: "#E11384"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1356,
    width: 113,
    height: 10,
    fill: "#467839"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    width: 113,
    height: 10,
    fill: "#D2A025"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 791,
    width: 113,
    height: 10,
    fill: "#901135"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 452,
    width: 113,
    height: 10,
    fill: "#F03F25"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    width: 113,
    height: 10,
    fill: "#F99E20"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 1469,
    width: 113,
    height: 10,
    fill: "#007EBC"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1694,
    width: 113,
    height: 10,
    fill: "#00548B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    width: 113,
    height: 10,
    fill: "#299B45"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 904,
    width: 113,
    height: 10,
    fill: "#F36E1F"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 565,
    width: 113,
    height: 10,
    fill: "#00AFD9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1243,
    width: 113,
    height: 10,
    fill: "#CE8C25"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1582,
    width: 113,
    height: 10,
    fill: "#3EB047"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1807,
    width: 113,
    height: 10,
    fill: "#133368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLine);
export default __webpack_public_path__ + "static/media/top-line.70978575a7e393406b5d11661d1f581e.svg";
export { ForwardRef as ReactComponent };